import React from 'react'

import { Platform } from 'react-native'

import {
  AppContentContainer as NativeContainer,
  AppContentContainerWeb,
} from './style'
import { useAppSelector } from '../../../../store/hooks'
import { useMobileCheck } from '../../../Util/useMobileCheck'

export const AppContentContainer = ({ children }) => {
  const settings = useAppSelector((state) => state.settings.values)

  const isSeamless = (settings && settings.isSeamlessIntegrated) || false
  const mobileCheck = useMobileCheck()

  if (Platform.OS === 'web') {
    return (
      <AppContentContainerWeb seamless={isSeamless} isMobile={mobileCheck}>
        {children}
      </AppContentContainerWeb>
    )
  }

  return <NativeContainer isMobile={mobileCheck}>{children}</NativeContainer>
}
